module.exports = __webpack_public_path__ + "static/blog-7-0e240667610dd8798f87a827704cf8f8.png";